import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useCart } from '../contexts/CartContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { productService } from '../services/productService';
import { getCategoryLabel } from '../constants/localCategories';
import { formatPrice } from '../utils/priceHelpers';

const ProductDetail = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const toast = useToast();
  const { addItem } = useCart();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const res = await productService.getProduct(productId);
      if (res.success) setProduct(res.product);
      setLoading(false);
    };
    load();
  }, [productId]);

  const handleAddToCart = () => {
    if (!user) {
      toast.info('Connectez-vous pour ajouter au panier');
      navigate('/login');
      return;
    }
    if (!product || product.stock <= 0) {
      toast.warning('Produit en rupture de stock');
      return;
    }
    addItem(product, quantity);
    toast.success('Ajouté au panier');
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="container" style={{ padding: 40 }}>
          Chargement…
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div>
        <Navbar />
        <div className="container" style={{ padding: 40 }}>
          <p>Produit introuvable.</p>
          <Link to="/shop">Retour à la boutique</Link>
        </div>
      </div>
    );
  }

  const images = product.images?.length ? product.images : product.thumbnailUrl ? [product.thumbnailUrl] : [];

  return (
    <div>
      <Navbar />
      <div className="container" style={{ padding: '30px 20px' }}>
        <Link to="/shop" style={{ color: '#666', marginBottom: 16, display: 'inline-block' }}>
          ← Retour à la boutique
        </Link>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 32,
          }}
        >
          <div>
            <div
              className="card"
              style={{
                height: 360,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              {images[0] ? (
                <img src={images[0]} alt={product.name} style={{ maxWidth: '100%', maxHeight: '100%' }} />
              ) : (
                <span style={{ fontSize: 80 }}>📦</span>
              )}
            </div>
          </div>

          <div>
            <span style={{ fontSize: 13, color: '#888' }}>{getCategoryLabel(product.category)}</span>
            <h1 style={{ margin: '8px 0 16px' }}>{product.name}</h1>
            <p style={{ fontSize: 28, fontWeight: 'bold', color: '#FF0000', marginBottom: 16 }}>
              {formatPrice(product.price)}
            </p>
            <p style={{ color: '#444', lineHeight: 1.6, marginBottom: 24 }}>
              {product.description || 'Aucune description.'}
            </p>
            <p style={{ marginBottom: 16 }}>
              {product.stock > 0 ? (
                <span style={{ color: '#28a745' }}>✓ {product.stock} en stock</span>
              ) : (
                <span style={{ color: '#dc3545' }}>Rupture de stock</span>
              )}
            </p>

            {product.stock > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                <label htmlFor="qty">Quantité</label>
                <input
                  id="qty"
                  type="number"
                  min={1}
                  max={product.stock}
                  value={quantity}
                  onChange={(e) => setQuantity(Math.min(product.stock, Math.max(1, Number(e.target.value) || 1)))}
                  style={{ width: 72, padding: 8, borderRadius: 8, border: '1px solid #ddd' }}
                />
              </div>
            )}

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <button
                type="button"
                className="btn btn-primary"
                disabled={product.stock <= 0}
                onClick={handleAddToCart}
              >
                Ajouter au panier
              </button>
              <Link to="/cart" className="btn btn-secondary">
                Voir le panier
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetail;
